import React from 'react';
import { isNotEmpty, prop, propEq } from 'ramda';
import BaseModal from '../../../../components/BaseModal';
import { getRolesToDisplayed } from '../../../../components/users/utils/roles';
import RoleCardList from './userForm/RoleCardList';
import { getUserRoles } from './utils';

const DeleteUserModal = ({ open, handleClose, user, teams, offers, onConfirm, isAdministration, loadingModal }) => {
  const roles = getRolesToDisplayed(getUserRoles(user, teams, offers));
  const isPending = propEq('pending', 'status', user);
  const typeUser = isPending ? 'une invitation' : 'un utilisateur';
  const title = isAdministration ? `Supprimer ${typeUser}` : `Retirer ${typeUser} de l\'équipe`;
  const info = isAdministration ? `Attention ! Vous allez supprimer ${typeUser} ${isNotEmpty(roles) ? 'ayant déjà au moins un rôle sur l\'une des équipes' : ''} :` : `Attention ! Vous allez retirer ${typeUser} de l\'équipe.`;
  const confirmText = `Confirmer${isAdministration ? ' la suppression' : ''}`;

  return (
    <BaseModal
      title={title}
      visible={open}
      onHide={() => handleClose(false)}
      type="danger"
      onClick={() => onConfirm(user)}
      confirmText={confirmText}
      loading={loadingModal}
    >
      <p>{info}</p>
      {!isAdministration && <p>Il n'aura plus accès aux offres de cette équipe.</p>}
      <strong className="text-black !mb-5">{prop('email', user)}</strong>
      {!isPending && (isNotEmpty(roles) ? <RoleCardList roles={roles} /> : <p className="text-flexi-grey">Pas de rôle affecté à cet utilisateur.</p>)}
    </BaseModal>
  );
};

export default DeleteUserModal;